import {
    Box,
    Container,
    Heading,
    HStack,
    Link,
    Stack,
    StackSeparator,
    Text,
    VStack,
} from "@chakra-ui/react"
import { useQuery } from "@tanstack/react-query"
import { createFileRoute } from "@tanstack/react-router"
import { getImprint } from "../../utils"
import NotFound from "../../components/Common/NotFound"
import { Link as LinkT } from "@tanstack/react-router"

export const Route = createFileRoute("/_layout/impressum")({
  component: Imprint,
  notFoundComponent: NotFound,
})

function Imprint() {
    const {data: imprint} = useQuery({
        ...getImprint()
    })

    return (
        <Container>
            <Heading size="4xl" color="main" mb={8}>Impressum</Heading>

            <Heading size="md" mb={2} color="main">Herausgeber und verantwortlich für den Inhalt der Internet-Seiten</Heading>
            <Text mb={2}>Wochen-Zeitung</Text>
            <Text mb={2}>Brennerstrasse 7</Text>
            <Text mb={4}>3550 Langnau i. E.</Text>

            <Text mb={2}>Telefon: <Link href="tel:+41 34 409 40 01" color="main">034 409 40 01</Link></Text>
            <Text mb={8}>E-Mail: <Link href="mailto:info@wochen-zeitung.ch" color="main">info@wochen-zeitung.ch</Link></Text>

            <Heading size="md" mb={2} color="main">Verlag</Heading>
            <Text mb={8}>Herrmann AG, Langnau i. E.</Text>

            <Heading size="md" mb={2} color="main">Herausgeber</Heading>
            <Text mb={8}>Thomas Herrmann</Text>

            <Heading size="md" mb={2} color="main">Geschäftsleiter</Heading>
            <Text mb={4}>Thomas Herrmann</Text>

            <Text mb={8}>Geschäftsleiter Thomas Herrmann im Interview - <Link href="https://www.youtube.com/watch?v=eRSkxC_nhr4" target="_blank" color="main">Hier ansehen</Link></Text>

            {imprint?.editorials &&
                <Box mb={8}>
                    <Heading size="md" mb={2} color="main">Redaktion</Heading>
                    {imprint?.editorials?.map((editorial, i) => (
                        editorial.show_profile ? (
                            <LinkT to="/autor/$authorId" params={{ authorId: editorial.id }}>
                                <Text mb={2} key={i}>{editorial.firstname ?? ""} {editorial.lastname ?? ""} {editorial.abbreviation ? `(${editorial.abbreviation})` : ""}</Text>
                            </LinkT>
                        ) : (
                            <Text mb={2} key={i}>{editorial.firstname ?? ""} {editorial.lastname ?? ""} {editorial.abbreviation ? `(${editorial.abbreviation})` : ""}</Text>
                        )
                    ))}
                </Box>
            }

            {imprint?.sport_editorials &&
                <Box mb={8}>
                    <Heading size="md" mb={2} color="main">Sport Redaktion</Heading>
                    {imprint?.sport_editorials?.map((editorial, i) => (
                        editorial.show_profile ? (
                            <LinkT to="/autor/$authorId" params={{ authorId: editorial.id }}>
                                <Text mb={2} key={i}>{editorial.lastname ?? ""} {editorial.firstname ?? ""} {editorial.abbreviation ? `(${editorial.abbreviation})` : ""}</Text>
                            </LinkT>
                        ) : (
                            <Text mb={2} key={i}>{editorial.lastname ?? ""} {editorial.firstname ?? ""} {editorial.abbreviation ? `(${editorial.abbreviation})` : ""}</Text>
                        )
                    ))}
                </Box>
            }

            <Heading size="md" mb={2} color="main">Werbung</Heading>
            <Text mb={8}>Peter Egli (<Link href="mailto:peter@wochen-zeitung.ch" color="main">peter@wochen-zeitung.ch</Link>)</Text>

            <Heading size="md" mb={2} color="main">Buchhaltung und Aboverwaltung</Heading>
            <Text mb={8}>Christine Wälti</Text>

            <Heading size="md" mb={2} color="main">Team der Herrmann AG</Heading>
            <Text mb={8}><Link href="https://www.herrmann-druck.ch/team" target="_blank" color="main">herrmann-druck.ch</Link></Text>

            <Heading size="md" mb={2} color="main">Annahmeschluss</Heading>
            <Heading size="md" mb={2}>Text</Heading>
            <Text mb={4}>Montag, 17:00 Uhr</Text>

            <Heading size="md" mb={2}>Inserate</Heading>
            <Text mb={8}>Dienstag, 12:00 Uhr</Text>

            <Text mb={8}>Die «Wochen-Zeitung» erscheint jeden Donnerstag.</Text>

            <Stack
                direction={{base: "column", md: "row"}}
                gap="10"
                divideX="2px"
                divideY="2px"
                divideColor="main"
                w="100%"
                my={8}
                separator={<StackSeparator />}
                color="secondary"
                alignItems="center"
                justifyContent="space-between"
            >
                {Number(imprint?.circulation_number) > 0 &&
                    <VStack
                        textAlign="center"
                        backgroundColor="main"
                        borderRadius="full"
                        aspectRatio={1}
                        display="flex"
                        justifyContent="center"
                        w={{base: "80%", md: "full"}}
                        maxW="12em"
                    >
                        <Text fontSize="md" whiteSpace="nowrap">Auflage</Text>
                        <HStack textStyle="3xl" fontWeight="medium">
                            {new Intl.NumberFormat("de-CH").format(Number(imprint?.circulation_number))}
                        </HStack>
                    </VStack>
                }

                {Number(imprint?.subscription_number) > 0 &&
                    <VStack
                        textAlign="center"
                        backgroundColor="main"
                        borderRadius="full"
                        aspectRatio={1}
                        display="flex"
                        justifyContent="center"
                        w={{base: "80%", md: "full"}}
                        maxW="12em"
                    >
                        <Text fontSize="md" whiteSpace="nowrap">Abos</Text>
                        <HStack textStyle="3xl" fontWeight="medium">
                            {new Intl.NumberFormat("de-CH").format(Number(imprint?.subscription_number))}
                        </HStack>
                    </VStack>
                }

                {Number(imprint?.reader_number) > 0 &&
                    <VStack
                        textAlign="center"
                        backgroundColor="main"
                        borderRadius="full"
                        aspectRatio={1}
                        display="flex"
                        justifyContent="center"
                        w={{base: "80%", md: "full"}}
                        maxW="12em"
                    >
                        <Text fontSize="md" whiteSpace="nowrap">LeserInnen</Text>
                        <HStack textStyle="3xl" fontWeight="medium">
                            {new Intl.NumberFormat("de-CH").format(Number(imprint?.reader_number))}
                        </HStack>
                    </VStack>
                }
            </Stack>

            <Heading size="md" color="main" mb={2}>Webseite und Webdesign</Heading>
            <Text mb={2}><Link href="https://www.herrmann-druck.ch" target="_blank" color="main">Herrmann AG</Link></Text>
            <Text mb={2}>Brennerstrasse 7</Text>
            <Text mb={8}>3550 Langnau i. E.</Text>

            <Heading size="md" color="main" mb={2}>Bildquellen</Heading>
            <Text mb={8}>Bildarchiv Wochen-Zeitung, Herrmann AG, falls nicht anders vermerkt.</Text>

            <Heading size="md" color="main" mb={2}>Disclaimer/Haftungsausschluss</Heading>
            <Text mb={4}>
                Der Herausgeber übernimmt keine Gewährleistung für Aktualität, Korrektheit, Vollständigkeit und Qualität der bereitgestellten Informationen.
                In keinem Fall haftet der Herausgeber für Verluste oder Schäden materieller oder immaterieller Art, die sich aus oder im Zusammenhang mit der Nutzung
                oder Nichtnutzung der angebotenen Informationen beziehungsweise durch die Nutzung fehlerhafter oder unvollständiger Informationen entstehen können.
            </Text>
            <Text mb={8}>
                Der Herausgeber behält sich ausdrücklich vor, jederzeit Inhalte ohne Ankündigung ganz oder teilweise zu ändern, zu löschen oder zeitweise nicht zu veröffentlichen.
                Der Herausgeber hat fremde, das heisst nicht auf Ihren Servern oder in Ihrem Einflussbereich liegende Websites, die mit dieser Website über Verknüpfungen
                (Hyperlinks) allenfalls verbunden sind, nicht überprüft und übernimmt keine Verantwortung für deren Inhalte, die darauf angebotenen Produkte, Dienstleistungen
                oder sonstigen Angebote.
            </Text>

            <Heading size="md" color="main" mb={2}>Urheberrechte</Heading>
            <Text mb={8}>
                Der gesamte Inhalt und die Struktur der Webseiten ist urheberrechtlich geschützt. Die vollständige oder teilweise Reproduktion, die elektronische oder mit anderen
                Mitteln erfolgte Übermittlung, die Modifikation oder die Benutzung für öffentliche oder kommerzielle Zwecke ist ohne vorherige schriftliche Zustimmung des
                Herausgebers untersagt.
            </Text>

            <Heading size="md" color="main" mb={2}>E-Mail-Kommunikation</Heading>
            <Text mb={8}>
                Die E-Mail-Kommunikation mit dem Herausgeber findet derzeit offen und unverschlüsselt statt. Es kann somit nicht ausgeschlossen werden, dass so gesendete Daten
                von Dritteneingesehen und Kontaktaufnahmen zu unserer Institution nachvollzogen werden können. Zudem zirkulieren die Daten unter Umständen grenzüberschreitend,
                selbst wenn sich Sender und Empfänger im gleichen Staat befinden. Die Diskretion bei der Kommunikation via E-Mail ist somit nicht gewährleistet.
            </Text>

            <Heading size="md" color="main" mb={2}>Google Analytics</Heading>
            <Text mb={4}>
                Diese Website benutzt Google Analytics, einen Webanalysedienst der Google Inc. („Google“). Google Analytics verwendet sog. „Cookies“, Textdateien, die auf Ihrem
                Computer gespeichert werden und die eine Analyse der Benutzung der Website durch Sie ermöglicht. Die durch den Cookie erzeugten Informationen über Ihre Benutzung
                dieser Website (einschliesslich Ihrer IP-Adresse) wird an einen Server von Google in den USA übertragen und dort gespeichert.
            </Text>
            <Text mb={4}>
                Google wird diese Informationen benutzen, um Ihre Nutzung der Website auszuwerten, um Reports über die Websiteaktivitäten für die Websitebetreiber zusammenzustellen
                und um weitere mit der Websitenutzung und der Internetnutzung verbundene Dienstleistungen zu erbringen. Auch wird Google diese Informationen gegebenenfalls an Dritte
                übertragen, sofern dies gesetzlich vorgeschrieben oder soweit Dritte diese Daten im Auftrag von Google verarbeiten. Google wird in keinem Fall Ihre IP-Adresse
                mit anderen Daten der Google in Verbindung bringen.
            </Text>
            <Text mb={8}>
                Sie können die Installation der Cookies durch eine entsprechende Einstellung Ihrer Browser Software verhindern; wir weisen Sie jedoch darauf hin, dass Sie in
                diesem Fall gegebenenfalls nicht sämtliche Funktionen dieser Website vollumfänglich nutzen können. Durch die Nutzung dieser Website erklären Sie sich mit der
                Bearbeitung der über Sie erhobenen Daten durch Google in der zuvor beschriebenen Art und Weise und zu dem zuvor benannten Zweck einverstanden.
            </Text>

            <Heading size="md" color="main" mb={2}>Änderungen</Heading>
            <Text mb={4}>
                Wir können das Impressum jederzeit ohne Vorankündigung anpassen. Es gilt die jeweils aktuelle, auf unserer Website publizierte Fassung.
            </Text>
            <Text>Letzte Änderung 08.12.2025</Text>
      </Container>
    )
}
